import type { PricingRuleInput } from "@/lib/api/paid-access";

export type DurationPreset = "permanent" | "30" | "90" | "365" | "custom";

export interface RuleRow extends PricingRuleInput {
  durationPreset: DurationPreset;
}

export function presetToDays(preset: DurationPreset, customDays?: number): number | null {
  if (preset === "permanent") return null;
  if (preset === "custom") return customDays ?? null;
  return Number(preset);
}

export function rulesToRows(
  rules: Array<{
    patronTypeId: string;
    price: string;
    currency: string;
    accessDurationDays: number | null;
  }>
): RuleRow[] {
  return rules.map((r) => ({
    patronTypeId: r.patronTypeId,
    price: Number(r.price),
    currency: r.currency,
    accessDurationDays: r.accessDurationDays,
    durationPreset: r.accessDurationDays == null ? "permanent" : "custom",
  }));
}
